<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <div style="display: flex">
    <tui-textfield [tuiTextfieldCleaner]="false" tuiTextfieldSize="s" style="width: 100%">
      <label tuiLabel *ngIf="!formControl.value">Выберите диапазон дат</label>
      <input
        tuiInputDateRange
        [formControl]="formControl"
      />
      <tui-calendar-range *tuiTextfieldDropdown/>
    </tui-textfield>

    <button *ngIf="hasValue" nbButton size="small" status="control" (click)="clear()" type="button">
      <nb-icon icon="close"/>
    </button>

  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
